export { default } from "./TemplateCardPlaceholder";
